<div
  class="pointer-events-none inline-block h-full select-none"
  [ngClass]="{
    'rotate-0': orientation() === 'left',
    'rotate-90': orientation() === 'up',
    'rotate-180': orientation() === 'right',
    'rotate-270': orientation() === 'down',
  }"
>
  <div class="absolute size-full">
    <div class="absolute inset-0 flex -translate-x-[75%] translate-y-[2%] -rotate-90 animate-pulse items-center justify-center">
      <img class="h-full w-full scale-[180%] transform object-contain brightness-90 saturate-200" [src]="assetPath + 'pipe-glow.png'" />
    </div>
  </div>
  <img class="relative size-full object-contain" [src]="assetPath + 'pipe-front.png'" />
</div>
